import React, { useCallback } from 'react';
import { ISoldToTableData } from '../../../actions/get-sold-tos.action';

interface BackButtonProps {
    step: number;
    setStep: (step: number) => void;
    setSoldTo: (data: ISoldToTableData) => void;
    resources: {
        createOrderPreviousPageButton: string;
    };
    pushHistoryState: (currentStep: number) => void;
}

export const BackButton: React.FC<BackButtonProps> = React.memo(({ step, setStep, setSoldTo, resources, pushHistoryState }) => {
    const handlePreviousClick = useCallback(() => {
        if (step === 2) {
            setSoldTo({} as ISoldToTableData);
        }
        pushHistoryState(step - 1);
        setStep(step - 1);
    }, [step, setStep, setSoldTo]);

    if (![2, 5].includes(step)) {
        return null;
    }

    return (
        <button className='msc-cta__secondary' type='button' onClick={handlePreviousClick}>
            {resources.createOrderPreviousPageButton}
        </button>
    );
});
